import { usePublishedBoxStore } from '@/entities/sets/publish';
import { GoToPhase2Report } from '@/features/navigate';
import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { Pagination, ToolTip } from '@/shared/ui';
import { gradingSetMap, stateSetMap } from '@/shared/utils/publish';
import { PublishStntResetPasswordPopup } from '@/widgets/modal';
import { reportButtonStyles } from '@/widgets/published-box/ui/styles';
import { useRouter } from '@tanstack/react-router';

export const ByNicknameTable = ({ data }: { data?: API.IntegPubNickList.Res }) => {
    const { showModal } = useModalStore();
    const router = useRouter();
    const { searchPage, setSearchPage } = usePublishedBoxStore();
    const detailData = data?.publishList;
    const pageData = data?.page;

    const onStntManagement = (item: DATA.PublishNickListType) => {
        showModal({
            isCustom: true,
            id: 'publish-reset-password',
            initContents: () => <PublishStntResetPasswordPopup data={item} />,
        });
    };

    return (
        <div className="table-board // con-mt3">
            <div className="table-board__body table-style1">
                <table>
                    <colgroup>
                        <col style={{ width: '66px' }} />
                        <col style={{ width: '160px' }} />
                        <col style={{ width: '112px' }} />
                        <col />
                        <col style={{ width: '130px' }} />
                        <col style={{ width: '104px' }} />
                        <col style={{ width: '140px' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">NO</th>
                            <th scope="col">닉네임</th>
                            <th scope="col">학생 관리</th>
                            {/* <th scope="col">용도</th> */}
                            <th scope="col">제목</th>
                            <th scope="col">응시 기간</th>
                            <th scope="col">채점 여부</th>
                            <th scope="col">리포트</th>
                        </tr>
                    </thead>
                    <tbody className="align-center">
                        {detailData?.map((item, idx) => {
                            return (
                                <tr key={`nickname-table-${idx}`}>
                                    <td className="txt1">
                                        {pageData && pageData?.number * 10 + idx + 1}
                                    </td>
                                    <td>{item.nickNm}</td>
                                    <td>
                                        <button
                                            type="button"
                                            className="btn btn-default line small"
                                            title={item.publishNm}
                                            onClick={() => onStntManagement(item)}
                                        >
                                            학생 관리
                                        </button>
                                    </td>
                                    {/* <td>
                                        <span className={`row-use ${useSetMap[item.use]}`}>
                                            {item.use}
                                        </span>
                                    </td> */}
                                    <td className="row-link">
                                        <button
                                            type="button"
                                            className="link"
                                            onClick={() => {
                                                router.navigate({
                                                    to: `/sets/published-box/detail/${item.publishId}`,
                                                });
                                            }}
                                        >
                                            <span className="txt">{item.publishNm}</span>
                                            {item.sttsNm && (
                                                <span
                                                    className={`row-state ${stateSetMap[item.sttsNm]}`}
                                                >
                                                    {item.sttsNm}
                                                </span>
                                            )}
                                        </button>
                                    </td>
                                    <td className="txt1 align-left">
                                        {`${item.pdPublishStDt}~
                    ${item.pdPublishEdDt}`}
                                    </td>
                                    <td
                                        className={
                                            item.checkStts
                                                ? `row-grading ${gradingSetMap[item.checkStts]}`
                                                : ''
                                        }
                                    >
                                        {item.checkStts ? item.checkStts : '-'}
                                    </td>
                                    <td>
                                        {item.sttsNm === '종료' ? (
                                            <ToolTip
                                                msg={
                                                    <p className="tip-txt">
                                                        응시 종료 후 리포트 생성에 <br />약 3분 정도
                                                        소요됩니다.
                                                    </p>
                                                }
                                            >
                                                <GoToPhase2Report
                                                    ct="student"
                                                    gubun="t"
                                                    publishType={item.publishType}
                                                    trgtId={item.trgtId}
                                                    stntId={item.stdtUserId}
                                                    nickname={item.nickNm}
                                                    styles={reportButtonStyles}
                                                    textbkId={item.textbkId}
                                                />
                                                {/* <GoToReport
                                                    isStnts={false}
                                                    trgtId={item?.trgtId}
                                                    stntId={item?.stdtUserId}
                                                    nickname={item?.nickNm}
                                                    styles={reportButtonStyles}
                                                    publishTab="닉네임별"
                                                    claId={item?.claId}
                                                    textbkId={item?.textbkId}
                                                    isStudent={false}
                                                    publishType={item?.publishType?.toString()}
                                                    setsId={data?.publishList?.[idx]?.setsId}
                                                /> */}
                                            </ToolTip>
                                        ) : (
                                            '-'
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <div className="table-board__footer">
                <Pagination
                    currentPage={searchPage}
                    totalPages={data?.page.totalPages!}
                    onChange={(page: number) => setSearchPage(page)}
                    pageBtnCount={10}
                />
            </div>
        </div>
    );
};
